//
// Monitors user activity to avoid performing unnecessary actions.
function AdsNinjaUserActivityMonitor(){

    this.__trackingStartTime          = Date.now();
    this.__userActivityLastRecorded   = Date.now();
    this.__longestStretchOfInactivity = 0;
    this.__totalTimeInactive          = 0;
    this.__throttleInterval           = 1000;
    this.__lastRecordedEvent          = null;
    this.__eventHelper                = new AdsNinjaEventHelper();

    this.__registerUserActivityEventListeners();
}

//
// Determines if user has been inactive for a span of at least X amount of time.
AdsNinjaUserActivityMonitor.prototype.hasUserBeenInactiveForThreshold = function(elapseTimeThresholdInMilliseconds){

    var elapseTime = Date.now() - this.__userActivityLastRecorded;

    if(elapseTime > this.__longestStretchOfInactivity){

        this.__longestStretchOfInactivity = elapseTime;
    }

    return (this.__longestStretchOfInactivity > elapseTimeThresholdInMilliseconds);
}

//
// Determines if user has been active in the last X amount of time.
AdsNinjaUserActivityMonitor.prototype.hasUserActivityBeenDetectedRecently = function(elapseTimeThresholdInMilliseconds){

    var elapseTime = Date.now() - this.__userActivityLastRecorded;

    if(elapseTime > this.__longestStretchOfInactivity){

        this.__longestStretchOfInactivity = elapseTime;
    }

    return (elapseTime < elapseTimeThresholdInMilliseconds);
}

//
// Determines if the total time a user was inactive exceeds a threshold.
AdsNinjaUserActivityMonitor.prototype.hasTotalUserInactivityExceededThreshold = function(elapseTimeThresholdInMilliseconds){

    var elapseTime = Date.now() - this.__userActivityLastRecorded;

    return (this.__totalTimeInactive + elapseTime > elapseTimeThresholdInMilliseconds);
}

//
// Determines if the total tracking time exceeded the threshold.
AdsNinjaUserActivityMonitor.prototype.hasTotalTrackingTimeExceededThreshold = function(elapseTimeThresholdInMilliseconds){

    return (this.getTotalTrackingTime() > elapseTimeThresholdInMilliseconds);
}

//
// Returns amount of time the monitor has been tracking user activity.
AdsNinjaUserActivityMonitor.prototype.getTotalTrackingTime = function(){

    return Date.now() - this.__trackingStartTime;
}

//
// Registers event listeners.
AdsNinjaUserActivityMonitor.prototype.__registerUserActivityEventListeners = function(){

    var self = this;

    var handleUserActivity = this.__eventHelper.throttle(function(event){

        var elapseTime                    = Date.now() - self.__userActivityLastRecorded;
        self.__totalTimeInactive          += elapseTime - self.__throttleInterval;
        self.__longestStretchOfInactivity = (elapseTime > self.__longestStretchOfInactivity) ? elapseTime : self.__longestStretchOfInactivity;
        self.__userActivityLastRecorded   = Date.now();
        self.__lastRecordedEvent          = event.type || null;
    }, this.__throttleInterval);

    var options = (this.__eventHelper.arePassiveEventListenersSupported()) ? {passive: true} : false;

    document.addEventListener('scroll', handleUserActivity, options); // TODO: Remove this.
    document.addEventListener('touchstart', handleUserActivity, options);
    document.addEventListener('touchmove', handleUserActivity, options);
    document.addEventListener('mousedown', handleUserActivity, options);
    document.addEventListener('mousemove', handleUserActivity, options);
    document.addEventListener('keydown', handleUserActivity, options);
}

window.AdsNinjaUserActivityMonitor = AdsNinjaUserActivityMonitor;